import { usePageTracking } from '@/hooks/useAnalytics';

/**
 * Component that tracks page views when routes change
 * Just include this once in your app
 */
export default function AnalyticsPageTracker() {
  // Hook will automatically track page views when the route changes
  usePageTracking();
  
  // This component doesn't render anything
  return null;
} 